import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import UserProfile from './UserProfile';

const VOLUNTEER_ROUTES = ['/volunteer/register', '/volunteer/summer-camp'];

const Navigation = () => {
  const location = useLocation();
  const isVolunteerPage = VOLUNTEER_ROUTES.includes(location.pathname);
  const isSummerCamp = location.pathname === '/volunteer/summer-camp';

  if (isVolunteerPage) {
    return (
      <nav className="bg-white shadow-md">
        <div className="container-custom">
          <div className="flex justify-between items-center h-14 sm:h-16 px-3 sm:px-0">
            {/* Left: YK Logo */}
            <Link to="/" className="flex items-center flex-shrink-0">
              <img
                src="https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png"
                alt="Yugal Kunj"
                className="h-8 sm:h-14 w-auto"
              />
            </Link>

            {/* Center: Page Title */}
            <div className="flex-1 text-center px-2 sm:px-4">
              <span className="text-base sm:text-xl font-bold text-gray-800 tracking-tight whitespace-nowrap">
                {isSummerCamp ? 'Summer Camp Volunteer' : 'Volunteer Registration'}
              </span>
            </div>

            {/* Right: RMS + HYC logos — hidden on mobile */}
            <div className="hidden sm:flex items-center gap-3 flex-shrink-0">
              <img
                src="https://www.radhamadhavsociety.org/assets/images/about/i-logo-2.png"
                alt="Radha Madhav Society"
                className="h-8 w-auto object-contain"
                onError={e => { e.target.style.display = 'none'; }}
              />
              <div className="w-px h-8 bg-gray-200" />
              <img
                src="https://harmonyyouthcenter.org/Content/images/footer.png"
                alt="Harmony Youth Center"
                className="h-8 w-auto object-contain"
                onError={e => { e.target.style.display = 'none'; }}
              />
            </div>
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="bg-white shadow-md">
      <div className="container-custom">
        <div className="flex justify-between items-center h-16">
          {/* YK Logo - Left Corner */}
          <Link to="/" className="flex items-center">
            <img
              src="https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png"
              alt="Yugal Kunj"
              className="h-14 w-auto"
            />
          </Link>

          {/* Login Button - Right Corner */}
          <div className="flex items-center">
            <UserProfile />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
